import { jsx as t } from "react/jsx-runtime";
import f from "react";
import { O as o, A as s } from "./ApartmentCard-BfyZfamk.js";
import { B as d } from "./BuildingCard-DK7g1PNq.js";
const l = {
  "card-grid": "elo-card-grid"
}, c = f.forwardRef(
  ({ cardData: a }, i) => /* @__PURE__ */ t("div", { className: l["card-grid"], ref: i, children: a.map((r, e) => r.type === "office" ? /* @__PURE__ */ t(o, { ...r.data }, e) : r.type === "apartment" ? /* @__PURE__ */ t(s, { ...r.data }, e) : r.type === "building" ? /* @__PURE__ */ t(d, { ...r.data }, e) : null) })
);
export {
  c as C
};
